module.exports = __webpack_public_path__ + "img/nohands.ddc50069.svg";